export default "__VITE_ASSET__DLHjUrC$__"